module.exports = __webpack_public_path__ + "./favicons/favicon-16x16.png";